export default "__VITE_ASSET__MujCDDRj__"